module.exports = ".footer-copyright{\r\n  background-color: #0d47a1\r\n}\r\n\r\n.page-footer{\r\n\r\n  background-color: #283593;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/lans-footer/lans-footer.component.css
// module id = ./src/app/lans-footer/lans-footer.component.css
// module chunks = main